var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('v-datetime-picker',{attrs:{"outline":""},model:{value:(_vm.formfield.value),callback:function ($$v) {_vm.$set(_vm.formfield, "value", $$v)},expression:"formfield.value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }